import { orderItemStatus, WS_EVENT_TYPES } from "@/utils/constants";
import { trueSet } from "@/utils/pureFunctions";

export const departmentSocketService = {
  [WS_EVENT_TYPES.ORDER_ITEM_UPDATE_EVENT](data) {
    const { id: orderItemId, orderId } = data;
    const orderIndex = this.orders.findIndex((item) => item.id === orderId);
    if (orderIndex === -1) return { orderIndex: null, orderItemIndex: null };
    const orderItemIndex = this.orders[orderIndex].items.findIndex(
      (item) => item.id === orderItemId
    );
    if (orderItemIndex === -1) return { orderIndex, orderItemIndex: null };
    const orderItem = {
      ...this.orders[orderIndex].items[orderItemIndex],
      ...data,
    };
    this.orders[orderIndex].items[orderItemIndex].splice(
      orderItemIndex,
      1,
      orderItem
    );
  },
  [WS_EVENT_TYPES.ORDER_ITEM_DELETE_EVENT](data) {
    const { orderItemId, orderId } = data;
    const orderIndex = this.orders.findIndex((item) => item.id === orderId);
    if (orderIndex !== -1) {
      const hasOneOrderItem = this.orders[orderIndex].items.length === 1;
      if (hasOneOrderItem) {
        this.orders.splice(orderIndex, 1);
      } else {
        this.orders[orderIndex].items = this.orders[orderIndex].items.filter(
          (item) => item.id !== orderItemId
        );
      }
    }
  },
  [WS_EVENT_TYPES.ORDER_SEND_EVENT](data) {
    const orderIndex = this.orders.findIndex((item) => item.id === data.id);
    if (orderIndex !== -1) {
      let order = {
        ...this.orders[orderIndex],
        ...data,
        items: this.orders[orderIndex].items.map((item) => {
          item.state = orderItemStatus.TO_REVIEW_WAREHOUSE;
          return item;
        }),
      };
      this.orders.splice(orderIndex, 1, order);
    }
  },
  [WS_EVENT_TYPES.ORDER_CREATE_EVENT](data) {
    data.show = true;
    data.owner = trueSet(data.owner);
    data.parentClassName = "row-fade-animate";
    this.setSuccess({ text: this.$t("addedNewOrder") });
    this.orders.unshift({});
    this.$set(this.orders, 0, data);
  },
  [WS_EVENT_TYPES.ORDER_ITEM_CREATE_EVENT](data) {
    const { orderId } = data;
    const orderIndex = this.orders.findIndex((item) => item.id === orderId);
    if (orderIndex !== -1) {
      data.childClassName = "row-fade-animate";
      this.orders[orderIndex].items.push(data);
    }
  },
  [WS_EVENT_TYPES.ORDER_ITEM_CHANGE_STATUS_REJECT_EVENT](data) {
    const { orderItemId, orderId, ...args } = data;
    const orderIndex = this.orders.findIndex((item) => item.id === orderId);
    if (orderIndex !== -1) {
      let orderItemIndex = this.orders[orderIndex].items.findIndex(
        (item) => item.id === orderItemId
      );
      if (orderItemIndex !== -1) {
        this.orders[orderIndex].items.splice(orderItemIndex, 1, {
          ...this.orders[orderIndex].items[orderItemIndex],
          ...args,
        });
      }
    }
  },
  [WS_EVENT_TYPES.ORDER_ITEM_CHANGE_STATUS_EVENT](data) {
    const { orderItemId, orderId, ...args } = data;
    const orderIndex = this.orders.findIndex((item) => item.id === orderId);
    if (orderIndex !== -1) {
      let orderItemIndex = this.orders[orderIndex].items.findIndex(
        (item) => item.id === orderItemId
      );
      if (orderItemIndex !== -1) {
        this.orders[orderIndex].items.splice(orderItemIndex, 1, {
          ...this.orders[orderIndex].items[orderItemIndex],
          ...args,
        });
      }
    }
  },
};
